import React from "react";
import { NavLink } from "react-router-dom";

const Menus = () => {
  return (
    <>
      <li>
        <NavLink to="/">Home</NavLink>
      </li>
      <li>
        <NavLink to="/jobs">Jobs</NavLink>
      </li>
      <li>
        <NavLink to="/companies">Companies</NavLink>
      </li>
      <li>
        <NavLink to="/about">About Us</NavLink>
      </li>
      <li>
        <NavLink to="/blog">Blog</NavLink>
      </li>
      <li>
        <NavLink to="/contact">Contact Us</NavLink>
      </li>
      <li>
        <NavLink to="/login">Sign In</NavLink>
      </li>
      <li>
        <NavLink to="/register" className="btn registerBtn">
          Sign In
        </NavLink>
      </li>
    </>
  );
};

export default Menus;
